var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"22d143e467ca50876db1e366f70a64fb37dde590"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"22d143e467ca50876db1e366f70a64fb37dde590"};
      